import { Box, Grid } from '@mui/material'
import { Context, useState } from 'react'
import { ILocality } from 'src/generated-types'
import { IMainComponent } from 'src/generated-types/main-component'
import { REPORT_MIN_HEIGHT_PX } from './DocumentsAndEventsSection.action'
import DocumentSection from './DocumentSection'
import MainComponentEventsSection from './MainComponentEventsSection'
import ReportSection from './ReportSection'

interface Props {
  context: Context<any> | null | undefined
  customerId: EntityId | undefined
  localityId: EntityId | undefined
  mainComponentId: any
  mainComponent: IMainComponent | undefined
  locality: ILocality | undefined
  isReadOnly?: boolean
}

const DocumentsAndEventsSection = ({
  context,
  customerId,
  localityId,
  mainComponentId,
  mainComponent,
  locality,
  isReadOnly,
}: Props) => {
  const [documentContentHeight, setDocumentContentHeight] = useState<number | null>(null)
  const [documentCount, setDocumentCount] = useState(0)
  const [reportCount, setReportCount] = useState(0)

  const showEventsInline = documentContentHeight != null && documentContentHeight > window.innerHeight / 3

  const eventsSection = <MainComponentEventsSection context={context} mainComponentId={mainComponentId as EntityId} />

  return (
    <>
      <Grid container spacing={1} mt={1} alignItems="stretch">
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            minWidth: 300,
            maxHeight: 'calc(100vh - 250px)',
            display: 'grid',
            overflow: 'hidden',
          }}
        >
          <DocumentSection
            context={context}
            customerId={customerId as EntityId}
            localityId={localityId}
            mainComponentId={mainComponentId}
            mainComponent={mainComponent}
            locality={locality}
            isReadOnly={isReadOnly}
            reportCount={reportCount}
            onDocumentCountChange={setDocumentCount}
            onContentHeightChange={setDocumentContentHeight}
          />
        </Grid>
        <Grid item md={6} xs={12} sx={{ minWidth: 300, width: '100%', display: 'grid' }}>
          <Box display="flex" flexDirection="column" gap={2} height="100%">
            <Box
              sx={{
                flex: '1 1 auto',
                minHeight: `${REPORT_MIN_HEIGHT_PX}px`,
                display: 'grid',
              }}
            >
              <ReportSection
                context={context}
                customerId={customerId as EntityId}
                localityId={localityId}
                mainComponentId={mainComponentId}
                mainComponent={mainComponent}
                locality={locality}
                isReadOnly={isReadOnly}
                documentCount={documentCount}
                onReportCountChange={setReportCount}
                height={REPORT_MIN_HEIGHT_PX}
              />
            </Box>
            {showEventsInline && (
              <Box sx={{ flex: '0 1 auto', minHeight: '250px', maxHeight: '350px', display: 'grid' }}>
                {eventsSection}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
      {!showEventsInline && <Box mt={2}>{eventsSection}</Box>}
    </>
  )
}

export default DocumentsAndEventsSection
